import { formatBrazilDateTimeCompact, parseBrazilDateTime, todayBrazilDateInput } from './timezone';

export const API = `${window.location.origin}/api`;

export function norm(str) {
  return (str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
}


export function fmtDate(dateStr) {
  if (!dateStr) return '';
  if (/[+-]\d{2}:\d{2}$|Z$/.test(dateStr) || /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(dateStr) || /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(dateStr)) return formatBrazilDateTimeCompact(dateStr, dateStr);
  let datePart = dateStr;
  let timePart = '';
  if (dateStr.includes('T')) {
    [datePart, timePart] = dateStr.split('T');
  } else if (dateStr.includes(' ')) {
    [datePart, timePart] = dateStr.split(' ');
  }
  const parts = datePart.split('-');
  if (parts.length === 3) {
    const formatted = `${parts[2]}/${parts[1]}/${parts[0]}`;
    return timePart ? `${formatted} ${timePart.slice(0, 5)}` : formatted;
  }
  return dateStr;
}

/** Parse "YYYY-MM-DD" or "YYYY-MM-DDTHH:mm" as local date (avoids UTC midnight offset) */
export function parseLocalDate(dateStr) {
  return parseBrazilDateTime(dateStr) || new Date(`${todayBrazilDateInput()}T12:00:00-03:00`);
}

export function calcAge(dobStr) {
  if (!dobStr) return '';
  const [y, m, d] = dobStr.split('-').map(Number);
  const [todayY, todayM, todayD] = todayBrazilDateInput().split('-').map(Number);
  let age = todayY - y;
  if (todayM < m || (todayM === m && todayD < d)) age--;
  return `${age} anos`;
}

export function calcAgeNum(dobStr) {
  if (!dobStr) return null;
  const [y, m, d] = dobStr.split('-').map(Number);
  const [todayY, todayM, todayD] = todayBrazilDateInput().split('-').map(Number);
  let age = todayY - y;
  if (todayM < m || (todayM === m && todayD < d)) age--;
  return age;
}

export function formatPhone(value) {
  let digits = value.replace(/\D/g, '');
  if (digits.length > 11 && digits.startsWith('55')) digits = digits.slice(2);
  digits = digits.slice(0, 11);
  if (digits.length <= 2) return digits.length ? `(${digits}` : '';
  if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7, 11)}`;
}

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const ATRIBUICOES = [
  { value: 'primeira_fila', label: 'Primeira Fila' },
  { value: 'segunda_fila', label: 'Segunda Fila' },
  { value: 'terceira_fila', label: 'Terceira Fila' },
  { value: 'quarta_fila', label: 'Quarta Fila' },
  { value: 'individual', label: 'Individual' },
  { value: 'oracao', label: 'Oração' }
];

export const INSTRUMENTOS = [
  'Acordeon', 'Clarinete', 'Clarinete Alto', 'Clarinete Baixo', 'Corne Inglês',
  'Eufonio', 'Fagote', 'Flauta', 'Flugelhorn', 'Oboé', 'Piano',
  'Sax Alto', 'Sax Barítono', 'Sax Soprano', 'Sax Tenor',
  'Trombone', 'Trompa', 'Trompete', 'Tuba',
  'Viola', 'Violão', 'Violino', 'Violoncelo'
];

export const ACTION_LABELS = {
  'attendance_created': 'Presença registrada',
  'attendance_updated': 'Presença atualizada',
  'event_created': 'Evento criado',
  'event_updated': 'Evento atualizado',
  'event_deleted': 'Evento excluído',
  'event_closed': 'Evento fechado',
  'event_auto_closed': 'Evento fechado automaticamente',
  'pessoa_created': 'Pessoa cadastrada',
  'pessoa_updated': 'Pessoa atualizada',
  'pessoa_updated_by_auxiliar': 'Pessoa atualizada por auxiliar',
  'pessoa_deleted': 'Pessoa excluída',
  'pessoa_approved': 'Cadastro aprovado',
  'pessoa_rejected': 'Cadastro rejeitado',
  'pending_update_approved': 'Atualização aprovada',
  'auxiliar_created': 'Auxiliar cadastrado',
  'auxiliar_updated': 'Auxiliar atualizado',
  'auxiliar_deleted': 'Auxiliar excluído',
  'role_changed': 'Permissão alterada',
  'settings_updated': 'Configurações atualizadas',
  'pessoas_imported': 'Importação em massa',
  'bulk_assign_auxiliar': 'Atribuição em massa de auxiliar',
  'bulk_assign_fila': 'Atribuição em massa de fila',
  'fila_created': 'Atribuição criada',
  'fila_updated': 'Atribuição atualizada',
  'fila_deleted': 'Atribuição excluída',
  'tipo_evento_created': 'Tipo de evento criado',
  'tipo_evento_updated': 'Tipo de evento atualizado',
  'tipo_evento_deleted': 'Tipo de evento excluído',
  'reuniao_created': 'Reunião criada',
  'reuniao_updated': 'Reunião atualizada',
  'reuniao_deleted': 'Reunião excluída',
  'reuniao_concluida': 'Reunião concluída',
  'reuniao_em_andamento': 'Reunião em andamento',
  'reuniao_revert_agendada': 'Reunião revertida para agendada',
  'reuniao_revert_em_andamento': 'Reunião revertida para em andamento',
  'impersonate': 'Visualização como auxiliar',
  'impersonate_admin': 'Visualização como admin',
  'church_created': 'Igreja criada',
  'church_updated': 'Igreja atualizada',
  'church_deleted': 'Igreja excluída',
  'church_admin_added': 'Admin adicionado à igreja',
  'church_admin_removed': 'Admin removido da igreja',
  'pessoa_inativada': 'Pessoa inativada',
  'pessoa_reativada': 'Pessoa reativada',
  'anotacao_created': 'Anotação criada',
  'anotacao_updated': 'Anotação atualizada',
  'anotacao_deleted': 'Anotação excluída',
  'pending_update_rejected': 'Atualização rejeitada',
  'motivo_inativacao_created': 'Motivo de inativação criado',
  'motivo_inativacao_updated': 'Motivo de inativação atualizado',
  'motivo_inativacao_deleted': 'Motivo de inativação excluído',
  'pergunta_created': 'Pergunta registrada',
  'pergunta_updated': 'Pergunta atualizada',
  'pergunta_deleted': 'Pergunta excluída',
  'pergunta_toggled': 'Pergunta marcada como respondida',
  'visita_created': 'Visita criada',
  'visita_status_updated': 'Status da visita atualizado',
  'visita_deleted': 'Visita excluída',
  'link_created': 'Link criado',
  'link_updated': 'Link atualizado',
  'link_deleted': 'Link excluído',
  'link_toggled': 'Link ativado/desativado',
  'votacao_created': 'Votação criada',
  'votacao_updated': 'Votação atualizada',
  'votacao_deleted': 'Votação excluída',
  'votacao_enviada': 'Votação enviada',
  'votacao_encerrada': 'Votação encerrada',
  'votacao_reaberta': 'Votação reaberta',
  'event_deleted_by_visita': 'Evento de visita excluído',
  'user_login': 'Login realizado',
  'votacao_respondida': 'Votação respondida',
  'votacao_resposta_editada': 'Resposta de votação editada',
  'pergunta_publica_enviada': 'Pergunta enviada (público)',
  'visita_publica_enviada': 'Visita solicitada (público)',
};

/** Returns '#FFFFFF' or '#1E293B' based on background luminance */
export function getFilaTextColor(hex) {
  if (!hex || hex.length < 4) return '#1E293B';
  let r, g, b;
  if (hex.length === 4) {
    r = parseInt(hex[1] + hex[1], 16);
    g = parseInt(hex[2] + hex[2], 16);
    b = parseInt(hex[3] + hex[3], 16);
  } else {
    r = parseInt(hex.slice(1, 3), 16);
    g = parseInt(hex.slice(3, 5), 16);
    b = parseInt(hex.slice(5, 7), 16);
  }
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? '#1E293B' : '#FFFFFF';
}

export const ACTION_COLORS = {
  'created': 'bg-green-100 text-green-700',
  'approved': 'bg-green-100 text-green-700',
  'updated': 'bg-blue-100 text-blue-700',
  'deleted': 'bg-red-100 text-red-700',
  'rejected': 'bg-red-100 text-red-700',
  'closed': 'bg-orange-100 text-orange-700',
};
